import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      error: false,
    }
  },
  components: {
    'banner-btn-cmp': BannerBtn,
  },
  methods: {
    errorData(data) {
      this.error = data.error
    },
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/services/index.js